import { Octokit, RestEndpointMethodTypes } from '@octokit/rest';
import { ApplicationConfigurationService } from '@src/core/application-configuration';
import { ServiceModuleReadmeResponse, ServiceModulesApi } from 'cmp-client-api';
import { GithubServiceInterface } from './types/github.service.interface';

export class GithubService implements GithubServiceInterface {
  private readonly service: Octokit;

  private readonly cmpService: ServiceModulesApi;

  public constructor(service: Octokit, cmpService: ServiceModulesApi) {
    this.service = service;
    this.cmpService = cmpService;
  }

  public async getReadme(moduleName: string): Promise<ServiceModuleReadmeResponse> {
    const fullModuleName: string = `sm-${moduleName}`;
    return this.service.rest.repos
      .getReadme({
        owner: ApplicationConfigurationService.getConfiguration().VITE_GITHUB_OWNER,
        repo: fullModuleName,
      })
      .then((response: RestEndpointMethodTypes['repos']['getReadme']['response']) => ({
        readme: window.atob(response.data.content).toString(),
        gitUrl: response.url,
      }))
      .catch(() => this.cmpService.getServiceModuleReadme(fullModuleName).then(({ data }) => data));
  }
}
